
import isMob768 from "@/mixins/isMob";
import lazyload from "@/directives/lazyload";
import { email, required, minLength } from "vuelidate/lib/validators";

import blueSms from "@/assets/images/landing/svg/i-miss-you.svg";
import greySms from "@/assets/images/landing/svg/message-grey.svg";
import "@/plugins/vuelidate"

export default {
  data() {
    return {

      displayDays: "00",
      displayHours: "00",
      displayMinutes: "00",
      displaySeconds: "00",
      deadline: "Oct 5, 2021 20:45:00",
      loadedTime: false,
      expired: false,
      images: {
        // iphone,
        blueSms,
        greySms,
      },
      formLogin: {
        name: "",
        email: "",
      },
    };
  },

mixins: [isMob768],

  validations: {
    formLogin: {
      name: { required, minLength: minLength(2) },
      email: { email, required },
    },
  },
  mounted() {

    const endDate = parseFloat(localStorage.endDate);
    if (endDate) {
      this.deadline = endDate;
      this.showRemaining();
    } else {
      var t = new Date();
      var end = t.getTime() + 24 * 60 * 60 * 1000;
      this.deadline = end;
      this.showRemaining();
    }


  },
  directives: {
    lazyload,
  },

  watch: {
    '$store.state.stepsUserModule.searchName': {
      immediate: true,
      handler(newName) {
        this.formLogin.name = newName;
      }
    },
    '$store.state.stepsUserModule.searchEmail': {
      immediate: true,
      handler(newEmail) {
        this.formLogin.email = newEmail;
      }
    },
  },

  computed: {

    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    },

    name: {
      get() {
        return this.$store.state.stepsUserModule.searchName;
      },
      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_NAME', value);
      }
    },
    email: {
      get() {
        return this.$store.state.stepsUserModule.searchEmail;
      },
      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_EMAIL', value);
      }
    }      
  },


  methods: {

    redirectUser() {
      this.name = this.formLogin.name;
      this.email = this.formLogin.email;

      if (!this.formLogin.name || !this.formLogin.email) {
        return;
      }

      const utmParams = localStorage.utmParams;
      let url = `/auth/register?plan=5&product=DS`;

      if (utmParams) {
        url = `${url}&${utmParams}`;
      }
      this.$router.push(`${this.$store.state.userModule.isLogged ? '/account/search-credits/' : '/auth/register?plan=5&product=DS'}`);
    },

    formatNum: (num) => (num < 10 ? "0" + num : num),
    showRemaining() {
      const timer = setInterval(() => {
        const now = new Date();
        const distance = this.deadline - now.getTime();

        if (distance < 0) {
          clearInterval(timer);
          return;
        }

        const days = Math.floor(distance / this._days);
        const hours = Math.floor((distance % this._days) / this._hours);
        const minutes = Math.floor((distance % this._hours) / this._minutes);
        const seconds = Math.floor((distance % this._minutes) / this._seconds);
        this.displayDays = this.formatNum(days);
        this.displayHours = this.formatNum(hours);
        this.displayMinutes = this.formatNum(minutes);
        this.displaySeconds = this.formatNum(seconds);
        this.loadedTime = true;
      }, 1000);
    },
  },
};
